import {
  RESET_SCROLL_POSITION,
  SET_SCROLL_POSITION,
  REMOVE_NAVBAR_TOP,
  ACTIVE_NAVBAR_TOP,
} from "../types/scroll.types";

export function setScrollPosition(position) {
  return { type: SET_SCROLL_POSITION, position };
}

export function resetScrollPosition() {
  return { type: RESET_SCROLL_POSITION };
}

export function removeNavBar() {
  return { type: REMOVE_NAVBAR_TOP };
}

export function activeNavBar() {
  return { type: ACTIVE_NAVBAR_TOP };
}
